import 'css-chunksrc/client/pages/personalSpacePage/synthesis/tasks/styles.scss';export default {
  "tasks": "_tasks_18vzj_1",
  "list": "_list_18vzj_8"
};